export default __webpack_public_path__ + "static/media/basic_thumb.b6b142c0.jpg";